export function validatePhone() {
	if (typeof (epi) == 'undefined' || typeof (epi.EPiServer) == 'undefined' || typeof (epi.EPiServer.Forms) == 'undefined' || typeof ($) == 'undefined') {
		return;
	}

    const customElements = {};
    const PHONE_VALIDATOR = 'EPiServer.Forms.Samples.Implementation.Validation.PhoneValidator';
	const setCustomPhoneValidator = function() {
		$('.Form__Element[data-f-type="textbox"]').each(function() {
			const $input = $(this).find('input');
			const name = ($input.data('name') || '').toLowerCase();
			if (isPhonePattern(name)) {
				const name = $input.attr('name');
				const id = $input.attr('id');
				customElements[name] = id;
			}
		});
	};

    /**
	 * Replace 0064 to 0 for input mobile
	 * */
	const replacePhone = function() {
		$('.Form__Element[data-f-type="textbox"]').each(function() {
			const $input = $(this).find('input');
			const name = ($input.data('name') || '').toLowerCase();
			if (isPhonePattern(name)) {
				$input.on('change', function() {
					let value = $(this).val();
					if ((/^0064[0-9]*$/).test(value)) {
						value = value.replace('0064', '0');
						$(this).val(value);
					}
				});
			}
		});
	};

	const phoneValidate = function(fieldName, fieldValue, validatorMetaData) {
		let result = {
			isValid: true,
		};
		if (!('' == fieldValue || fieldValue && !fieldValue.length)) {
			if (!(/^[a-zA-Z0-9]*$/).test(fieldValue)) {
				result = {
					isValid: false,
					message: 'Please remove any special characters',
				};
			} else if (!(/^[0-9]*$/).test(fieldValue)) {
				result = {
					isValid: false,
					message: 'Please enter a valid phone number',
				};
			} else if (!(/^0[0-9]*$/).test(fieldValue)) {
				result = {
					isValid: false,
					message: 'Phone number should begin with 0',
				};
			} else if (!(/^(02|03|04|06|07|09)[0-9]*$/).test(fieldValue)) {
				result = {
					isValid: false,
					message: 'Please enter a valid mobile or landline number',
				};
			} else if ((/^02[0-9]*$/).test(fieldValue) && !(/^.{9,15}$/).test(fieldValue)) {
				result = {
					isValid: false,
					message: 'Phone should be within 7 and 13 numbers after the prefix 02',
				};
			} else if (!(/^02[0-9]*$/).test(fieldValue) && !(/^.{9}$/).test(fieldValue)) {
				result = {
					isValid: false,
					message: `Phone should be 7 numbers after the prefix ${fieldValue.slice(0, 2)}`,
				};
			}
		}
		return result;
	};

	const isPhonePattern = function(name) {
		return name === 'phone' || name === 'mobile';
	};

	setCustomPhoneValidator();
	replacePhone();

    // extend the EpiForm JavaScript API in ViewMode
    $.extend(true, window.epi.EPiServer.Forms, {
        // extend the Validator to validate Visitor's value in Clientside.
        // Serverside's Fullname of the Validator instance is used as object key (Case-sensitve) to lookup the Clientside validate function.
        Validators: {
            [PHONE_VALIDATOR]: phoneValidate,
        },

        Validation: {
            // OVERRIDE to add phone validate
            getElementValidators: function(e, t) {
                if (e instanceof Array && 0 !== e.length && t) {
                    Object.keys(customElements).forEach(function(name) {
                        const phoneValidate = e.find((item) => item.targetElementName === name || item.targetElementId === customElements[name]);
                        if (phoneValidate) {
                            const isExistPhoneValidator = phoneValidate.validators.find((item) => item.type === PHONE_VALIDATOR);
                            !isExistPhoneValidator && phoneValidate.validators.push({
                                type: PHONE_VALIDATOR,
                            });
                        } else {
                            e.push({
                                targetElementName: name,
                                targetElementId: customElements[name],
                                validators: [{
                                    type: PHONE_VALIDATOR,
                                }],
                            });
                        }
                    });
                    for (let n = 0, i = e.length, a = null; n < i; n++) {
						if ((a = e[n]) && (a.targetElementId === t || a.targetElementName === t)) return a.validators;
					}
                }
            },
        },
    });
}



// WEBPACK FOOTER //
// ./epi-form-validate.js